// AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
// Source of truth: shared/tool_names.py
// Regenerate with: python scripts/generate-tool-names-ts.py

export const ToolNames = {
  BUILD_TIRE_CATEGORY_BROWSE_URL: "build_tire_category_browse_url",
  CHECK_TIRE_WHEEL_COMPATIBILITY: "check_tire_wheel_compatibility",
  CONNECT_TO_SPECIALIST: "connect_to_specialist",
  GENERATE_TDG_LINK: "generate_tdg_link",
  GET_PAGE_DESCRIPTIONS: "get_page_descriptions",
  GET_PAGE_LINKS: "get_page_links",
  GET_SURVEY_RATINGS_BY_TIRE: "get_survey_ratings_by_tire",
  GET_TIRE_CATEGORY_INFO: "get_tire_category_info",
  GET_TIRE_SPECS_BY_MANUFACTURER: "get_tire_specs_by_manufacturer",
  GET_TIRE_VARIANTS_BY_MODEL: "get_tire_variants_by_model",
  GET_VEHICLE_FITMENT: "get_vehicle_fitment",
  QUERY_TIRE_KNOWLEDGE_BASE: "query_tire_knowledge_base",
  REDIRECT_TO_SALES: "redirect_to_sales",
  RESOLVE_TIRE_MODEL: "resolve_tire_model",
  SEARCH_PAGE_CONTENT: "search_page_content",
  SHOW_SELECTION_CARDS: "show_selection_cards",
  SHOW_SIZE_SEARCH_LINK_CARD: "show_size_search_link_card",
  SHOW_SOURCE_CARDS: "show_source_cards",
  SHOW_TDG_LINK_CARD: "show_tdg_link_card",
  SHOW_TEXT_RESPONSE: "show_text_response",
  SHOW_YMMV_INTERFACE: "show_ymmv_interface",
  VALIDATE_TIRE_SIZE: "validate_tire_size",
} as const;

export type ToolName = (typeof ToolNames)[keyof typeof ToolNames];
